import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=3285a8b0&"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=3285a8b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports